import React from "react";
import { Checkbox } from "primereact/checkbox";

const CommonCheckbox = ({
  name,
  label,
  options = [],
  isMultiple = false,
  getValues,
  setValue,
  errors,
  checkboxStyle,
  styleBox=false
}) => {

  const handleChange = (e, value) => {
    if (isMultiple) {
      const currentValues = getValues(name) || [];
      if (e.target.checked) {
        setValue(name, [...currentValues, value], { shouldValidate: true });
      } else {
        setValue(
          name,
          currentValues.filter((item) => item !== value),
          { shouldValidate: true }
        );
      }
    } else {
      setValue(name, e.target.checked ? value : null, { shouldValidate: true });
    }
  };

  return (
    <div className={`${styleBox===true ? "d-flex" : ""}`} style={styleBox ? { gap: "26%" } : {}}>
      {options.length > 0 ? (
        options.map((option) => (
          <div
            key={option.value}
            className={`field-checkbox align-items-center  ${checkboxStyle ? "ms-2 mt-2" : "ms-4 mt-3"} `}
          >
            <Checkbox
              inputId={`${name}-${option.value}`}
              value={option.value}
              checked={
                isMultiple
                  ? (getValues(name) || []).includes(option.value)
                  : getValues(name) === option.value
              }
              onChange={(e) => handleChange(e, option.value)}
            />
        <label htmlFor={`${name}-${option.value}`} className="ml-2 color-label">
              {option.label}
            </label>
          </div>
        ))
      ) : (
        <div className="field-checkbox align-items-center mt-3 ms-4">
          <Checkbox
            inputId={name}
            checked={getValues(name) || false}
            onChange={(e) => handleChange(e, true)}
          />
          <label htmlFor={name} className="ml-2 text-sm color-label">
            {label}
          </label>
        </div>
      )}
      {errors?.[name] && (
        <small className="p-error">{errors[name]?.message}</small>
      )}
    </div>
  );
};

export default CommonCheckbox;

